module.exports = __webpack_public_path__ + "static/media/email-send.1409b780.svg";